import React, { useEffect } from 'react';
import { LOYALTY_IN_PAGE_BANNER_CONFIG } from '../../config/setup/setup';
import { inPageInitLibrary } from './InPageInitLibrary';

/** Third party script inits to inject cashback banner into the site. Also generates a modal. */
const LoyaltyInPageBanner = () => {
  const { key, id } = LOYALTY_IN_PAGE_BANNER_CONFIG[
    process.env.NEXT_PUBLIC_SITE
  ];
  useEffect(() => {
    inPageInitLibrary(key);
  }, []);

  return <div id={id} />;
};

export default LoyaltyInPageBanner;
